import {
    DRAW_APPROVE_SUCCESS,
    DRAW_CHANGES_FAILURE,
    DRAW_CHANGES_REQUEST,
    DRAW_CHANGES_SUCCESS,
    DRAW_REOPEN_SUCCESS,
    DRAW_RESET_SUCCESS,
    DRAW_SWAP_SUCCESS,
    COMPETITIONS_DELETE_DRAW_SUCCESS,
    COMPETITIONS_MAKE_DRAW_SUCCESS,
} from 'actions';

const initialState = {
    byKey: {},     // 'competitionId:categoryId' → {status, manualChanges, changes}
    fetching: [],  // keys with an in-flight request
};

const keyOf = (competition, category) => `${competition}:${category}`;

const mutatedKey = action => {
    const { competition, category, result } = action;
    if (competition && category) {
        return keyOf(competition, category);
    }
    const entity = Array.isArray(result) ? result[0] : result;
    if (entity && entity.competition && entity.category) {
        return keyOf(entity.competition.id, entity.category.id);
    }
    return null;
};

/**
 * Manual-change report of a category Draft (diff vs the generated draw,
 * with who/when per moved athlete). Mutations DROP the cached entry — the
 * module refetches, the backend stays the single source of truth.
 */
export const drawChangesReducer = (state = initialState, action) => {
    switch (action.type) {
        case DRAW_CHANGES_REQUEST: {
            const key = keyOf(action.competition, action.category);
            return { ...state, fetching: [...state.fetching, key] };
        }

        case DRAW_CHANGES_SUCCESS: {
            const key = keyOf(action.competition, action.category);
            return {
                byKey: { ...state.byKey, [key]: action.data },
                fetching: state.fetching.filter(k => k !== key),
            };
        }

        case DRAW_CHANGES_FAILURE: {
            const key = keyOf(action.competition, action.category);
            return { ...state, fetching: state.fetching.filter(k => k !== key) };
        }

        case DRAW_SWAP_SUCCESS:
        case DRAW_RESET_SUCCESS:
        case DRAW_APPROVE_SUCCESS:
        case DRAW_REOPEN_SUCCESS:
        case COMPETITIONS_MAKE_DRAW_SUCCESS:
        case COMPETITIONS_DELETE_DRAW_SUCCESS: {
            const key = mutatedKey(action);
            if (!key || !(key in state.byKey)) {
                return state;
            }
            const byKey = { ...state.byKey };
            delete byKey[key];
            return { ...state, byKey };
        }

        default: {
            return state;
        }
    }
};
